import { render, staticRenderFns } from "./simple-object-list.vue?vue&type=template&id=141e6951&scoped=true"
import script from "./simple-object-list.vue?vue&type=script&lang=js"
export * from "./simple-object-list.vue?vue&type=script&lang=js"
import style0 from "./simple-object-list.vue?vue&type=style&index=0&id=141e6951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e6951",
  null
  
)

export default component.exports